import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { call as v } from "../../_utils/vue/call.js";
import { ref as O } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { computed as l } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function q(n, K) {
  const {
    paginatedDataRef: t,
    treeMateRef: d,
    selectionColumnRef: f
  } = K, R = O(n.defaultCheckedRowKeys), w = l(() => {
    var e;
    const {
      checkedRowKeys: a
    } = n, c = a === void 0 ? R.value : a;
    return ((e = f.value) === null || e === void 0 ? void 0 : e.multiple) === !1 ? {
      checkedKeys: c.slice(0, 1),
      indeterminateKeys: []
    } : d.value.getCheckedKeys(c, {
      cascade: n.cascade,
      allowNotLoaded: n.allowCheckingNotLoaded
    });
  }), u = l(() => w.value.checkedKeys), N = l(() => w.value.indeterminateKeys), C = l(() => new Set(u.value)), g = l(() => new Set(N.value)), r = l(() => {
    const {
      value: e
    } = C;
    return t.value.reduce((a, c) => {
      const {
        key: o,
        disabled: h
      } = c;
      return a + (!h && e.has(o) ? 1 : 0);
    }, 0);
  }), y = l(() => t.value.filter((e) => e.disabled).length), L = l(() => {
    const {
      length: e
    } = t.value, {
      value: a
    } = g;
    return r.value > 0 && r.value < e - y.value || t.value.some((c) => a.has(c.key));
  }), b = l(() => {
    const {
      length: e
    } = t.value;
    return r.value !== 0 && r.value === e - y.value;
  }), S = l(() => t.value.length === 0);
  function s(e, a, c) {
    const {
      "onUpdate:checkedRowKeys": o,
      onUpdateCheckedRowKeys: h,
      onCheckedRowKeysChange: m
    } = n, i = [], {
      value: {
        getNode: _
      }
    } = d;
    e.forEach((x) => {
      var k;
      const I = (k = _(x)) === null || k === void 0 ? void 0 : k.rawNode;
      i.push(I);
    }), o && v(o, e, i, {
      row: a,
      action: c
    }), h && v(h, e, i, {
      row: a,
      action: c
    }), m && v(m, e, i, {
      row: a,
      action: c
    }), R.value = e;
  }
  function U(e, a = !1, c) {
    if (!n.loading) {
      if (a) {
        s(Array.isArray(e) ? e.slice(0, 1) : [e], c, "check");
        return;
      }
      s(d.value.check(e, u.value, {
        cascade: n.cascade,
        allowNotLoaded: n.allowCheckingNotLoaded
      }).checkedKeys, c, "check");
    }
  }
  function A(e, a) {
    n.loading || s(d.value.uncheck(e, u.value, {
      cascade: n.cascade,
      allowNotLoaded: n.allowCheckingNotLoaded
    }).checkedKeys, a, "uncheck");
  }
  function D(e = !1) {
    const {
      value: a
    } = f;
    if (!a || n.loading)
      return;
    const c = [];
    (e ? d.value.treeNodes : t.value).forEach((o) => {
      o.disabled || c.push(o.key);
    }), s(d.value.check(c, u.value, {
      cascade: !0,
      allowNotLoaded: n.allowCheckingNotLoaded
    }).checkedKeys, void 0, "checkAll");
  }
  function E(e = !1) {
    const {
      value: a
    } = f;
    if (!a || n.loading)
      return;
    const c = [];
    (e ? d.value.treeNodes : t.value).forEach((o) => {
      o.disabled || c.push(o.key);
    }), s(d.value.uncheck(c, u.value, {
      cascade: !0,
      allowNotLoaded: n.allowCheckingNotLoaded
    }).checkedKeys, void 0, "uncheckAll");
  }
  return {
    mergedCheckedRowKeySetRef: C,
    mergedCheckedRowKeysRef: u,
    mergedInderminateRowKeySetRef: g,
    someRowsCheckedRef: L,
    allRowsCheckedRef: b,
    headerCheckboxDisabledRef: S,
    doUpdateCheckedRowKeys: s,
    doCheckAll: D,
    doUncheckAll: E,
    doCheck: U,
    doUncheck: A
  };
}
export {
  q as useCheck
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/use-check.js
// module id = 1659
// module chunks = 67